import { useMutation } from '@tanstack/react-query';

import { SESSION_STORAGE_KEYS } from 'src/utils/constants';

import axios from 'src/lib/axios';

interface UpdateRoleRequest {
  tenant_id: string;
}

const syncRoles = async (payload: UpdateRoleRequest) => {
  const response = await axios.patch(`/user/roles`, payload);
  return response.data;
};

export function useUpdateRole() {
  const { mutate: updateRole } = useMutation({
    mutationFn: async (payload: UpdateRoleRequest) => {
      const data = await syncRoles(payload);
      return data;
    },
    onSuccess: () => {
      // Store timestamp to indicate roles have been synced for this session
      sessionStorage.setItem(SESSION_STORAGE_KEYS.USER_ROLE_SYNC_TIMESTAMP, Date.now().toString());
    },
  });

  return { updateRole };
}
